type Rule<Err extends string, Param = {}> = {
  validator: (p: Param) => {
    isWarn?: boolean;
    error?: Err;
    meta?: Partial<Param>;
  };
  name: Err;
};

export type ExtractRuleNames<T extends readonly Rule<any, any>[]> =
  T[number]['name'];

type RuleNameToParams<T extends readonly Rule<any, any>[]> = {
  [K in ExtractRuleNames<T>]: Parameters<
    Extract<T[number], Rule<K, any>>['validator']
  >[0];
};

export const createRule = <Err extends string, Param = {}>({
  name,
  validator,
}: {
  name: Err;
  validator: (p: Param) => {
    isWarn?: boolean;
    error?: Err;
    meta?: Partial<Param>;
  };
}): Rule<Err, Param> => {
  return {
    name,
    validator,
  };
};

export const createValidationRunner = <T extends readonly Rule<any, any>[]>(
  rules: T,
) => {
  const validate = (params: RuleNameToParams<T>) => {
    for (let i = 0; i < rules.length; i++) {
      const r = rules[i];

      // @ts-expect-error
      const result = r.validator(params[r.name] as any);
      if (result.error) {
        return result;
      }
    }

    return {};
  };

  return validate;
};
